module.exports = __webpack_public_path__ + "static/media/masthead-narrogin-observer.4642ea30.svg";